
import { FC } from 'react';

const About: FC = () => {
  return (
    <div className="space-y-12">
      <div className="text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900">About Me</h1>
        <p className="mt-3 text-lg text-gray-600 max-w-3xl mx-auto">
          A dedicated and driven professional with a passion for law, public service, and strategic communication.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 items-start">
        <div className="md:col-span-2 space-y-6 text-gray-700 leading-relaxed">
          <p>
            My name is Spencer Hardesty Lewis, and I am a Juris Doctor Candidate at Loyola University New Orleans College of Law, where I am in the top 33% of my class. My expected graduation is May 2025. I am a proud alumnus of Texas State University, where I earned a Bachelor of Business Administration in Management.
          </p>
          <p>
            Before law school, I had the privilege of serving as the Director of Communications for Galveston County, Texas. In this role, I was the primary media contact for a county of over 350,000 residents. I managed all internal and external communications, from press releases to emergency guides, and played a key role in crisis communications during major weather events like Hurricane Nicholas.
          </p>
          <p>
            My experience also includes roles as a Quality Assurance Manager for a political consulting firm and as a Strategic Policy Director for a national non-profit. These positions have honed my skills in strategic planning, quality control, and policy development.
          </p>
          <p>
            I am fluent in Spanish and have an intermediate understanding of German, which has been invaluable in our increasingly globalized world. I am excited to bring my unique blend of legal education, communication skills, and public policy experience to new challenges.
          </p>
        </div>

        <div className="space-y-8">
          <div className="text-center">
            <img 
              src="/assets/images/headshot.jpg" 
              alt="Spencer Hardesty Lewis" 
              className="rounded-lg shadow-lg w-full object-cover border-4 border-white"
            />
            <p className="text-sm text-gray-500 mt-2">Spencer Hardesty Lewis</p>
          </div>
          <div className="text-center">
            <img 
              src="/assets/images/astros_game.jpg" 
              alt="Spencer at an Astros game" 
              className="rounded-lg shadow-lg w-full object-cover border-4 border-white"
            />
            <p className="text-sm text-gray-500 mt-2">At an Astros Game</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
